var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("バックアップファイル ダウンロード")]),_c('v-card',{staticClass:"pa-5",attrs:{"flat":"","outlined":""}},[_c('v-card-actions',[_c('v-spacer'),_c('Btn',{attrs:{"icon":"send","color":"success"},on:{"click":function($event){return _vm.backup()}}},[_vm._v("ダウンロード")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }